import { FC, ReactElement, SyntheticEvent } from "react";
import Sprite from "./Sprite";
import "./Museum.css";

interface MuseumProps {
  filename: string;
  maxX: number;
  maxY: number;
  width: number;
  height: number;
  marginX?: number;
  marginY?: number;
  originX?: number;
  originY?: number;
}

const Museum: FC<MuseumProps> = ({
  filename,
  maxX,
  maxY,
  width,
  height,
  marginX,
  marginY,
  originX,
  originY,
}) => {
  const sprites: ReactElement[] = [];
  for (let y = 0; y <= maxY; y++) {
    for (let x = 0; x <= maxX; x++) {
      sprites.push(
        <a
          title={`${x}-${y}`}
          key={`${x}-${y}`}
          onClick={(evt: SyntheticEvent) => {
            console.log("Sprite", { x, y });
            evt.preventDefault();
            return true;
          }}
        >
          <Sprite
            key={`${x}-${y}`}
            filename={filename}
            x={x}
            y={y}
            width={width}
            height={height}
            marginX={marginX}
            marginY={marginY}
            originX={originX}
            originY={originY}
          />
        </a>,
      );
    }
  }

  const gridCols = 4;

  return (
    <div className="w-full h-full bg-white">
      <div
        className="museum-box"
        style={{
          gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
          width: (width + 12) * gridCols,
          //height: (height + 12) * (maxY + 1),
        }}
      >
        {sprites}
      </div>
    </div>
  );
};
export default Museum;
